import {
  MessageCategory,
  MessageType,
  convertOCFolderItemToMessage,
} from 'utils/Message';
import { handleReponse } from 'actions';
import fetchAPI from 'utils/fetchAPI';

/**
 * SET OC FOLDER TABLE DIMENSIONS
 */

export const SET_OC_TABLE_DIMENSIONS = 'SET_OC_TABLE_DIMENSIONS';
const setDimensions = ({ width, height }) => ({
  type: SET_OC_TABLE_DIMENSIONS,
  width,
  height,
});

export const setOCFolderTableDimensions = ({ width, height }) => (
  dispatch,
  getState
) =>
  new Promise((resolve, reject) => {
    dispatch(setDimensions({ width, height }));
  });

/**
 * CLEAR OC FOLDER DATA
 */

export const CLEAR_OC_DATA = 'CLEAR_OC_DATA';

export const clearOCData = ({ group }) => ({
  type: CLEAR_OC_DATA,
  group,
});

/**
 * FETCH OC FOLDER
 */
export const INIT_OC_LOADING = 'INIT_OC_LOADING';
export const FINISH_OC_LOADING = 'FINISH_OC_LOADING';

export const initOCLoading = ({ offset, size, group }) => ({
  type: INIT_OC_LOADING,
  offset,
  size,
  group,
});

export const finishOCLoading = ({ offset, result, count, group }) => ({
  type: FINISH_OC_LOADING,
  offset,
  result,
  count,
  group,
});

const typesArrayMap = {
  all: [MessageType.IMAGE, MessageType.PDF, MessageType.FORM],
  form: [MessageType.FORM],
  image: [MessageType.IMAGE, MessageType.PDF],
};

export const getChannelFolder = ({ offset, size, group = 'all' }) => (
  dispatch,
  getState
) =>
  new Promise((resolve, reject) => {
    const channelId = getState().context.channel.id;
    dispatch(initOCLoading({ offset, size, group }));

    const token = getState().users.token;

    const messageTypes = typesArrayMap[group];
    if (messageTypes.length === 0) return;

    fetchAPI({
      endpoint:
        `/companies/channel/${channelId}/messages?size=${size}&from=${offset}` +
        `&${messageTypes.map(e => `message_types=${e}`).join('&')}`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    })
      .then(res => handleReponse(res))
      .then(json => {
        const count = json.summary.total;
        // const prevCount = getState().ocFolder.totalOCFormCount;
        const prevCount = getState().ocFolder[group].count;
        if (count !== prevCount || offset === 0) {
          dispatch(clearOCData({ group }));
        }
        const result = json.messages.map(e => {
          try {
            return convertOCFolderItemToMessage(e);
          } catch (err) {
            return {};
          }
        });
        return dispatch(
          finishOCLoading({
            offset,
            result,
            count,
            group,
          })
        );
      });
  });

export const saveOCDraft = ({ type, body }) => (dispatch, getState) =>
  new Promise((resolve, reject) => {
    const channelId = getState().context.channel.id;
    const token = getState().users.token;
    fetchAPI({
      endpoint: `/companies/channel/${channelId}/drafts`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      method: 'POST',
      body: JSON.stringify({
        type,
        body,
      }),
    })
      .then(res => handleReponse(res, dispatch))
      .then(json => resolve(json));
  });

export const importFromPersonalFolder = ({
  messages,
  channel_messages,
  chat_group_messages,
  drafts,
}) => (dispatch, getState) =>
  new Promise((resolve, reject) => {
    const channelId = getState().context.channel.id;
    const token = getState().users.token;
    fetchAPI({
      endpoint: `/companies/channel/${channelId}/user_messages/import`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      method: 'POST',
      body: JSON.stringify({
        message: messages,
        channel_message: channel_messages,
        chat_group_message: chat_group_messages,
        draft: drafts,
      }),
    })
      .then(res => handleReponse(res, dispatch))
      .then(json => resolve(json));
  });



// WEBPACK FOOTER //
// ./app/actions/OCFolderActionCreators.js